import { render, staticRenderFns } from "./applymodal.vue?vue&type=template&id=bc2caa56&scoped=true&"
import script from "./applymodal.vue?vue&type=script&lang=js&"
export * from "./applymodal.vue?vue&type=script&lang=js&"
import style0 from "./applymodal.vue?vue&type=style&index=0&id=bc2caa56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2caa56",
  null
  
)

export default component.exports